import {
    AutocompleteInput,
    BooleanField, BulkDeleteButton,
    Datagrid,
    DateField,
    ListProps,
    NullableBooleanInput,
    ReferenceField,
    ReferenceInput,
    TextField,
    TextInput,
} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {IdentifierField} from "../../components/IdentifierField";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../../shared/utils";
import {AddToNoteConfigurationGroupButton, CreateNoteConfigurationGroupButton} from "./NoteConfigurationBulkActions";

export const NoteConfigurationList = (props: ListProps) => {
  const {data: options} = useOptionsResource("GET");
  const filters = options ? [
    <TextInput alwaysOn {...initField("id", options)} />,
    <TextInput alwaysOn {...initField("configuration", options)} />,
    <ReferenceInput
      {...initField("client", options)}
      reference="autocomplete/subject"
      filter={{type: "client"}}
      label="Cliente"
    >
      <AutocompleteInput optionText="label" />
    </ReferenceInput>,
    <NullableBooleanInput source="final" label="Finale" />,
  ] : [];

  return options ? (
    <CustomList
      {...getDefaultListProps(props)}
      filters={filters}
      sort={{field: "updated_at", order: "DESC"}}
      bulkActionButtons={<><CreateNoteConfigurationGroupButton/><AddToNoteConfigurationGroupButton/><BulkDeleteButton/></>}
    >
      <Datagrid>
        <IdentifierField {...initField("id", options)} />
        <ReferenceField source="client" reference="subjects" link={false} label="Cliente">
          <TextField source="business_name" />
        </ReferenceField>
        <TextField {...initField("configuration", options)} />
        <BooleanField source="final" label="Finale" />
        <BooleanField source="qr_mode" label="QR" />
        <TextField source="children_count" label="Configurazioni" />
        <DateField source="updated_at" label="Ultima modifica" showTime />
      </Datagrid>
    </CustomList>
  ) : null;
};
